import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'

export default class AgrotechClassPartnerSpecialization extends BaseModel {
  id: number = 0
  name: string = ''
  latin: string = ''
  'sort_index': number = 0

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
